import React from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import EngagementSegments from './engagementSegments';
import PhysicianEngagementAffiliationType from './physicianEngagementAffiliationType';
import NpiEngagedPieChart from './npiEngagedPieChart';
import EngagementChannel from './engagementChannel';
import RepeatEngagementDistribution from '../repeatEngagementDistribution';
import HcpReachEngagement from '../hcpReachEngagement';

function PhysicianEngagement() {
    const { company } = useSelector((state) => state.company);
    const id = company?.id;

    const hideChannel = [].includes(id); // removed 64
    const showNpi = [64, 66, 161].includes(id);
    const repeatEngagement = [64, 66, 161].includes(id);

    const showHcpReach = id === 111;

    const showSegment = true;
    const showAffiliationType = [109].includes(id);
    const showChart = showNpi;
    const showEngagement = hideChannel; // !hideChannel will be added in future

    const segmentXS =
        showChart && showEngagement
            ? 6
            : showChart
              ? 6
              : showEngagement
                ? 4
                : showAffiliationType
                  ? 6
                  : 12;
    const chartXS = showChart ? (showEngagement ? 6 : 6) : 0;
    const channelXS = showEngagement ? (showChart && showSegment ? 12 : 8) : 0;

    return (
        <Grid item xs={12}>
            <Grid container spacing={3}>
                {showSegment && (
                    <Grid item xs={segmentXS}>
                        <EngagementSegments />
                    </Grid>
                )}
                {showHcpReach && (
                    <Grid item xs={12}>
                        <HcpReachEngagement />
                    </Grid>
                )}
                {showAffiliationType && (
                    <Grid item xs={segmentXS}>
                        <PhysicianEngagementAffiliationType />
                    </Grid>
                )}
                {showChart && (
                    <Grid item xs={chartXS}>
                        <NpiEngagedPieChart />
                    </Grid>
                )}
                {repeatEngagement && (
                    <Grid item xs={12}>
                        <RepeatEngagementDistribution />
                    </Grid>
                )}
                {showEngagement && (
                    <Grid item xs={channelXS}>
                        <EngagementChannel />
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
}

export default PhysicianEngagement;
